import { cn } from "@/lib/utils";

export interface LoadingProps {
  rows?: number;
  /** "dashboard": 3 tarjetas KPI + barra + filas (Dashboard). "list": solo filas, para listados/tablas (Catálogo). */
  variant?: "dashboard" | "list";
  className?: string;
  /** Texto opcional mostrado debajo del skeleton (accesibilidad + UX). */
  label?: string;
}

/** Loading/skeleton canónico del Design System (F3) — Dashboard y listados de Catálogo. */
export function Loading({ rows = 4, variant = "dashboard", className, label }: LoadingProps) {
  return (
    <div className={cn("animate-pulse space-y-4 p-4 sm:p-6", className)} role="status" aria-label={label ?? "Cargando"}>
      {variant === "dashboard" ? (
        <>
          <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {[1, 2, 3].map((i) => (
              <div key={i} className="glass-card h-28 rounded-xl" />
            ))}
          </div>
          <div className="glass-card h-10 w-full max-w-md rounded-lg" />
        </>
      ) : null}
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="glass-card h-16 rounded-xl" />
      ))}
      {label ? (
        <p className="text-center text-xs text-muted-foreground">{label}</p>
      ) : null}
    </div>
  );
}

/** Skeleton de página completa para rutas con ClinicalPageShell. */
export function CrudShellSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div className="animate-pulse space-y-3 p-4 sm:p-6" role="status" aria-label="Cargando">
      <div className="glass-card h-10 w-48 rounded-lg" />
      <div className="glass-card h-6 w-72 rounded" />
      <div className="mt-4 space-y-2">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="glass-card h-14 rounded-xl" />
        ))}
      </div>
    </div>
  );
}
